export default "__VITE_ASSET__aHMnP04g__"